import { createReduxServiceModule } from '@onhandtech/onhand-fe-shared/lib/redux'
import { createRequestError, formatEndpoint } from '@onhandtech/onhand-fe-shared/lib/request'
import type { RequestArgs } from '@onhandtech/onhand-fe-shared/lib/request/request.types'
import type { AxiosError } from 'axios'
import { getConfig } from 'config/configuration'
import type { SignupCodesResponse } from 'contracts/api/v4/signup-codes/signup-codes.service'

import { handleSuccess } from './handle-success'
import type { NormalisedSignupCodesResponse } from './signup-codes.module.types'
import { moduleName } from './signup-codes.module.types'

const { endpoints } = getConfig()

const args: RequestArgs<SignupCodesResponse, NormalisedSignupCodesResponse> = {
  method: 'GET',
  url: formatEndpoint(endpoints.api.v4.signUpCodes),
  handleFailure: (e: AxiosError) => createRequestError(e, moduleName),
  payload: {
    page: 1,
    size: 50,
  },
  handleSuccess,
}

const signUpCodesModule = () =>
  createReduxServiceModule<SignupCodesResponse, NormalisedSignupCodesResponse>({
    moduleName,
    args,
    downloadArgs: {
      ...args,
      downloadableFilename: 'signup-codes',
      downloadableFileType: 'csv',
    },
  })

export default signUpCodesModule
